import { render, staticRenderFns } from "./LegalAid.vue?vue&type=template&id=df397f48&"
import script from "./LegalAid.vue?vue&type=script&lang=js&"
export * from "./LegalAid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports